export default function Callout({ title, children, className = "", testid }) {
  return (
    <div className={`callout ${className}`} data-testid={testid}>
      {title && (
        <div className="text-[11px] uppercase tracking-[0.22em] text-navy font-bold mb-2">{title}</div>
      )}
      <div className="text-sm text-midnight">{children}</div>
    </div>
  );
}
